import React from 'react'
import isEqual from 'react-fast-compare'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import MUITextField from '@mui/material/TextField'

import NumberFormat from './NumberFormat'

const InputComponent = React.forwardRef((props, ref) => (
  <NumberFormat {...props} ref={ref} allowNegative={false} />
))

function PositiveFloatField (props) {
  const {
    name,
    InputProps = {},
    size = 'small',
    fullWidth = true,
    variant = 'outlined',
    decimalScale = 3,
    ...rest
  } = props

  return (
    <Field name={name}>
      {({ input, meta }) => (
        <MUITextField
          value={input.value}
          onChange={event => input.onChange(event.target.value)}
          error={meta.invalid}
          helperText={meta.submitError || meta.error}
          InputProps={{
            inputComponent: InputComponent,
            ...InputProps
          }}
          size={size}
          fullWidth={fullWidth}
          variant={variant}
          inputProps={{ decimalScale }}
          {...rest}
        />
      )}
    </Field>
  )
}

PositiveFloatField.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  InputProps: PropTypes.object,
  decimalScale: PropTypes.number,
}

export default React.memo(PositiveFloatField, isEqual)
